// ckeditor.js

import { ClassicEditor as ClassicEditorBase } from "@ckeditor/ckeditor5-editor-classic";
import { Essentials } from "@ckeditor/ckeditor5-essentials";
import { Autoformat } from "@ckeditor/ckeditor5-autoformat";
import { Bold, Italic } from "@ckeditor/ckeditor5-basic-styles";
import { BlockQuote } from "@ckeditor/ckeditor5-block-quote";
import { Heading } from "@ckeditor/ckeditor5-heading";
import { Link } from "@ckeditor/ckeditor5-link";
import { List } from "@ckeditor/ckeditor5-list";
import { Paragraph } from "@ckeditor/ckeditor5-paragraph";
import { SourceEditing } from "@ckeditor/ckeditor5-source-editing";
import { Alignment } from "@ckeditor/ckeditor5-alignment";
import { Table, TableToolbar } from "@ckeditor/ckeditor5-table";
import { Font } from "@ckeditor/ckeditor5-font";
import LineHeight from "../utils/ckeditor5-line-height-plugin/lineheight";

import { Image, ImageCaption, ImageResize, ImageStyle, ImageToolbar, ImageUpload } from "@ckeditor/ckeditor5-image";
import { LinkImage } from "@ckeditor/ckeditor5-link";
import { SimpleUploadAdapter } from "@ckeditor/ckeditor5-upload";

export default class ClassicEditor extends ClassicEditorBase {
  constructor(sourceElementOrData, config = {}) {
    super(sourceElementOrData, config);
    /* add translate text */
    // Make sure that the global object is defined. If not, define it.
    window.CKEDITOR_TRANSLATIONS = window.CKEDITOR_TRANSLATIONS || {};

    // Make sure that the dictionary for Polish translations exist.
    window.CKEDITOR_TRANSLATIONS["ja"] = window.CKEDITOR_TRANSLATIONS["ja"] || {};
    window.CKEDITOR_TRANSLATIONS["ja"].dictionary = window.CKEDITOR_TRANSLATIONS["ja"].dictionary || {};

    // Extend the dictionary for Polish translations with your translations:
    Object.assign(window.CKEDITOR_TRANSLATIONS["ja"].dictionary, {
      "Line Height": "行の高さ",
      "Font Size": "文字サイズ",
      "Align left": "左揃え",
      "Align right": "右揃え",
      "Align center": "中央揃え",
      Justify: "両端揃え",
      Default: "標準"
    });
  }
}

ClassicEditor.builtinPlugins = [
  Essentials,
  Autoformat,
  Bold,
  Italic,
  Font,
  LineHeight,
  BlockQuote,
  Heading,
  Link,
  List,
  Paragraph,
  Image,
  ImageToolbar,
  ImageCaption,
  ImageStyle,
  ImageResize,
  LinkImage,
  ImageUpload,
  SimpleUploadAdapter,
  SourceEditing,
  Alignment,
  Table,
  TableToolbar
];

ClassicEditor.defaultConfig = {
  toolbar: {
    items: [
      "heading",
      "|",
      "alignment:left",
      "alignment:right",
      "alignment:center",
      "alignment:justify",
      "|",
      "fontSize",
      "lineHeight",
      "|",
      "bold",
      "italic",
      "link",
      "bulletedList",
      "numberedList",
      "blockQuote",
      "undo",
      "redo",
      "|",
      "uploadImage",
      "insertTable",
      "sourceEditing"
    ]
  },
  fontSize: {
    options: [9, 11, 13, "default", 17, 19, 21]
  },
  lineHeight: {
    // specify your otions in the lineHeight config object. Default values are [ 0, 0.5, 1, 1.5, 2 ]
    options: [0.5, 0.75, 1, "default", 1.5, 1.75, 2]
  },
  table: {
    contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
  },
  simpleUpload: {
    uploadUrl: "https://0tcac3jzc9.execute-api.ap-northeast-1.amazonaws.com/v1/uploadimage"
  },
  image: {
    toolbar: [
      "imageStyle:inline",
      "imageStyle:block",
      "imageStyle:side",
      "|",
      "toggleImageCaption",
      "imageTextAlternative",
      "|",
      "linkImage"
    ],
    upload: { type: ["jpeg", "png", "gif", "bmp", "webp"] }
  },
  language: "ja"
};
